module.exports = __webpack_public_path__ + "static/media/undraw_enjoy.14e3d57d.png";